// react imports
import React, { useState } from "react";

// react router dom
import { useNavigate } from "react-router";

// prime react imports
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn
} from 'mdb-react-ui-kit';

// MULTILANGUAGE
import { withTranslation, Trans } from 'react-i18next';
import i18next from 'i18next';
import i18n from '../../../i18n';


/**
 * Props
 * @param visible: true
 * @param itemName: string
 * @param hideModal: () => void
 * @param onDelete: () => void
 * @returns
 */
const ProductDeleteModal = (props) => {
  // MULTILANGUAGE
  const { t } = i18n;

  // STATES
  const [deleteInProgress, setDeleteInProgress] = useState(false);

  return (
    <MDBModal
      className="standard-jc-modal product-delete"
      show={props.visible}
      backdrop={true}
      staticBackdrop={true}
      tabIndex='-1'
      onHidePrevented={props.hideModal}
    >
      <MDBModalDialog centered>
        <MDBModalContent>
          <MDBModalHeader>
            {/* <MDBModalTitle>Modal title</MDBModalTitle> */}
            <MDBBtn className='btn-close' color='none' onClick={props.hideModal}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>

            <i className="fa-regular fa-exclamation-triangle main-modal-icon"></i>

            <h3>{t('general_modals.delete_product.title', { item_name: props.item_name})}</h3>

            <p>{t('general_modals.delete_product.text')}</p>

            <button className="jc-btn black" onClick={() => {
              setDeleteInProgress(true);
              props.onDelete()
            }}>
              {deleteInProgress && <i className="fa-regular fa-spinner-third spinning"></i>}

              {!deleteInProgress && (
                <>
                  <i className="fa-regular fa-trash-alt"></i>
                  {t('general_modals.delete_product.button_text')}
                </>
              )}
            </button>

            <a
              className="brown-link"
              onClick={props.hideModal}
            >
              {t('general_modals.delete_product.cancel_text')}
            </a>
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
};

export default withTranslation()(ProductDeleteModal);

